export default "__VITE_ASSET__CIHkRKZZ__"